export function Skeleton({ isLoading }: { isLoading?: boolean }) {
  return (
    <div
      role="progressbar"
      className={`flex w-full flex-col gap-4 overflow-hidden ${isLoading && 'animate-pulse'}`}
    >
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={`item-${i}`} className="flex w-full gap-2 pl-5">
          <div className="flex size-6 rounded-full bg-cromai-m3-sys-light-background dark:bg-cromai-m3-sys-dark-surface2" />
          <div className="flex h-10 w-[90%] flex-col gap-2">
            <div className="mt-1 h-3 w-full rounded-sm bg-cromai-m3-sys-light-background dark:bg-cromai-m3-sys-dark-surface2" />
            <div className="h-2 w-3/4 rounded-sm bg-cromai-m3-sys-light-background dark:bg-cromai-m3-sys-dark-surface2" />
          </div>
        </div>
      ))}
    </div>
  )
}
